<template>
  <div class="page-404">
    404 - Not Found
  </div>
</template>
<script>
export default {}
</script>
